"use client";

import React from "react";
import ProductCard from "@/components/ProductCard/ProductCard";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Products } from "@/common/entities/product/Product";
import ProductsUtils, { ProductImageSizeType } from "@/common/utils/ProductsUtils";
import SwipperCarousel from "@/components/SwipperCarousel";
import { pushToDataLayer } from "@/common/utils/GtmUtils";

interface ProductsCarouselProps {
    title: string;
    products: Products[];
}

const ProductCarousel = ({ products, title }: ProductsCarouselProps) => {
    const productCards: any[] = [];
    const items: any[] = [];
    const productList: { list_id: string; list_name: string } = {
        list_id: title.replace(" ", "_"),
        list_name: title,
    };

    products.map((product: Products, index: number) => {
        productCards.push(
            <ProductCard
                key={product.id || index}
                imageSrc={ProductsUtils.getProductCoverImage(ProductImageSizeType.medium, product.defaultImage)}
                productName={product.name}
                availableToOrder={product?.productStock?.availableToOrder ?? false}
                stock={product.availableQuantity || 0}
                price={product.specialPriceWithVat ? product.specialPriceWithVat : product.priceWithVat}
                oldPrice={product.specialPriceWithVat ? product.priceWithVat : undefined}
                currency={"RON"}
                shortDescription={product?.shortDescription ?? ""}
                url={ProductsUtils.getProductLink(product.url, product.categories) || ""}
                displayPrice={product.productStock?.displayPrice ?? false}
                type={product.type}
                productData={product}
                fromDataLayer={productList.list_name}
            />,
        );

        const priceWithVat = Number(product.specialPriceWithVat ?? product.priceWithVat ?? 0);
        const priceWithoutVat = Number(product.specialPriceWithoutVat ?? product.priceWithoutVat ?? 0);
        const discount = product.specialPriceWithVat && product.priceWithVat ? priceWithoutVat - priceWithVat : 0;
        const defaultCategory = product.categories?.find((category: any) => category.default === true)?.category;
        const categoryName = defaultCategory?.name ?? product.categories?.[0]?.category?.name ?? "";
        items.push({
            item_name: product.name,
            item_id: product.id?.toString(),
            price: priceWithVat,
            price_tax_exc: priceWithoutVat,
            price_tax_inc: priceWithVat,
            item_brand: product.brand?.name ?? "",
            item_category: categoryName,
            discount: discount,
            quantity: 1,
            index: index + 1,
        });
    });
    pushToDataLayer("", { ecommerce: null });
    pushToDataLayer("view_item_list", { ecommerce: { item_list_id: productList.list_id, item_list_name: productList.list_name, items } });

    const carouselBreakpoints = {
        0: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        510: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 5,
        },
        1400: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    };

    if (!productCards?.length) {
        return <></>;
    }

    return (
        <div className="position-relative">
            <h2 className="sectionTitle mt-3">{title}</h2>
            <FaChevronLeft className="review-swiper-button-prev" />
            <FaChevronRight className="review-swiper-button-next" />
            <SwipperCarousel
                loop={false}
                breakpoints={carouselBreakpoints}
                pagination={{ clickable: true, dynamicBullets: true }}
                navigation={{
                    nextEl: ".review-swiper-button-next",
                    prevEl: ".review-swiper-button-prev",
                }}
                // @ts-ignore
                elements={productCards}
            />
        </div>
    );
};

export default ProductCarousel;
